var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 6,
    width: 17,
    height: 17,
    rx: 8.5,
    fill: "#87DDB4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87891 14.1211L14.1215 9.87845",
    stroke: "#272932",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46432 11.2925C8.46432 11.2925 7.17141 12.5854 6.343 13.4138C5.28236 14.4745 5.1079 16.4214 6.343 17.6565C7.57811 18.8916 9.52498 18.7171 10.5856 17.6565C11.6463 16.5958 12.707 15.5352 12.707 15.5352",
    stroke: "#272932",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5357 12.7075C15.5357 12.7075 16.8286 11.4146 17.657 10.5862C18.7176 9.52548 18.8921 7.57863 17.657 6.34352C16.4219 5.10842 14.475 5.28286 13.4144 6.34352C12.3537 7.40418 11.293 8.46484 11.293 8.46484",
    stroke: "#272932",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.d4eca64798ba893aea383447fc1695ff.svg";
export { ForwardRef as ReactComponent };